import English from './i18n.translations.en'
import Spanish from './i18n.translations.es'

export const en = English
export const es = Spanish
